import Image from "next/image";

export default function NextImage({
  src,
  alt,
  isOptimized = false,
  maxWidth = 1400,
  ...props
}: any) {
  const optimizedParams =
    !src?.includes(".gif") && isOptimized
      ? `?auto=format&q=80&fit=clip&w=${maxWidth}`
      : "";

  return <Image src={`${src}${optimizedParams}`} alt={alt} {...props} />;
}
